import { Flex } from '@chakra-ui/react';
import { SideMenuSettingsTrigger } from 'modules/Editor/components/SideMenuSettings/SideMenuSettingsTrigger';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ChartSwapper from 'widgets/ChartWidgets/DataTableChartCommon/ChartSwapper';
import { useWidget } from 'widgets/sdk';
import { InteractiveMenu } from 'widgets/sdk/Toolbar/InteractiveMenu';
import { checkIsWidgetTypeSupported } from 'widgets/sdk/Toolbar/InteractiveMenu/InteractiveMenu.helpers';

export const ChartWidgetToolbar = ({ showChartSwapper = true }): ReactElement => {
  const { t } = useTranslation('chart_widget', { useSuspense: false });
  const { widgetId } = useWidget();

  return (
    <Flex align='center' gap='2'>
      {showChartSwapper && (
        <>
          <ChartSwapper />
          <ToolbarDivider />
        </>
      )}
      <SideMenuSettingsTrigger>{t('editChart')}</SideMenuSettingsTrigger>
      <ToolbarDivider />
      <AltTextMenu widgetId={widgetId} />
      {checkIsWidgetTypeSupported(widgetId) && (
        <>
          <ToolbarDivider />
          <InteractiveMenu />
        </>
      )}
    </Flex>
  );
};
